import styled, { css } from 'styled-components'

export const Banner = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    align-self: center;
    gap: ${theme.space['16']};
    padding: ${theme.space['16']} ${theme.space['20']};
    background: ${theme.colors.blue100};
    border: ${theme.border.size['1']} solid ${theme.colors.blue200};
    border-radius: ${theme.border.radius['8']};
    max-width: 72rem;
    width: 100%;
  `,
)

export const StarImage = styled.img`
  width: 3.2rem;
  height: 3.2rem;
  flex-shrink: 0;
`

export const TextContent = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['2']};
    flex: 1;
    min-width: 0;
  `,
)
